import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export type DotStatus = "ok" | "warn" | "error" | "off";

const COLORS: Record<DotStatus, string> = {
  ok: "bg-success",
  warn: "bg-warning",
  error: "bg-destructive",
  off: "bg-muted-foreground",
};

/**
 * Colored status dot. The status is never conveyed by color alone: the localized text is either
 * visible (`showLabel`) or read by screen readers (`sr-only`).
 */
export function StatusDot({
  status,
  showLabel = false,
  className,
}: {
  status: DotStatus;
  showLabel?: boolean;
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <span className={cn("inline-flex items-center gap-1.5", className)} data-status={status}>
      <span aria-hidden className={cn("size-2.5 shrink-0 rounded-full", COLORS[status])} />
      <span className={showLabel ? "text-xs font-medium" : "sr-only"}>{t(`status.${status}`)}</span>
    </span>
  );
}
